// EtiquetasXL constants - S47.1 / S48.2a.
// Tamanos predefinidos (Avery US Letter + termicas en rollo + tecnica 100x50)
// y constantes del editor. Solo definiciones; sin logica.

// Conversion mm -> px para preview en pantalla.
// 96 DPI estandar Web (1 in = 25.4 mm, 1 in = 96 px).
export const PX_PER_MM = 96 / 25.4; // ~3.7795

// Grid del editor en mm. Snap visual 1mm.
export const GRID_MM = 1;

// Tipos de campo soportados (placeholders en S47.1; render real en S47.2).
export const FIELD_TYPES = ['text', 'price', 'sku', 'qr', 'barcode'];

// Etiquetas Avery sobre hoja Carta US (216 x 279 mm).
const PAGE_LETTER = { wMm: 215.9, hMm: 279.4 };

// Catalogo: 5160 / 5163 / 5164 + 3 termicas + S48.2a tecnica 100x50.
export const LABEL_SIZES = [
  {
    id: 'avery-5160',
    family: 'avery',
    label: 'Avery 5160 (25,4 x 66,7 mm)',
    page: PAGE_LETTER,
    wMm: 66.7,
    hMm: 25.4,
    cols: 3,
    rows: 10,
    marginTopMm: 12.7,
    marginLeftMm: 4.76,
    colGapMm: 3.18,
    rowGapMm: 0,
  },
  {
    id: 'avery-5163',
    family: 'avery',
    label: 'Avery 5163 (50,8 x 101,6 mm)',
    page: PAGE_LETTER,
    wMm: 101.6,
    hMm: 50.8,
    cols: 2,
    rows: 5,
    marginTopMm: 12.7,
    marginLeftMm: 4.76,
    colGapMm: 3.18,
    rowGapMm: 0,
  },
  {
    id: 'avery-5164',
    family: 'avery',
    label: 'Avery 5164 (84,7 x 101,6 mm)',
    page: PAGE_LETTER,
    wMm: 101.6,
    hMm: 84.7,
    cols: 2,
    rows: 3,
    marginTopMm: 12.7,
    marginLeftMm: 4.76,
    colGapMm: 6.35,
    rowGapMm: 0,
  },
  {
    id: 'thermal-50x25',
    family: 'thermal',
    label: 'Termica 50 x 25 mm',
    page: { wMm: 50, hMm: 25 },
    wMm: 50,
    hMm: 25,
    cols: 1,
    rows: 1,
    marginTopMm: 0,
    marginLeftMm: 0,
    colGapMm: 0,
    rowGapMm: 0,
  },
  {
    id: 'thermal-70x37',
    family: 'thermal',
    label: 'Termica 70 x 37 mm',
    page: { wMm: 70, hMm: 37 },
    wMm: 70,
    hMm: 37,
    cols: 1,
    rows: 1,
    marginTopMm: 0,
    marginLeftMm: 0,
    colGapMm: 0,
    rowGapMm: 0,
  },
  {
    id: 'thermal-100x150',
    family: 'thermal',
    label: 'Termica 100 x 150 mm',
    page: { wMm: 100, hMm: 150 },
    wMm: 100,
    hMm: 150,
    cols: 1,
    rows: 1,
    marginTopMm: 0,
    marginLeftMm: 0,
    colGapMm: 0,
    rowGapMm: 0,
  },
  {
    id: 'tecnica-100x50',
    family: 'thermal',
    label: 'Etiqueta tecnica 100x50',
    page: { wMm: 100, hMm: 50 },
    wMm: 100,
    hMm: 50,
    widthMm: 100,
    heightMm: 50,
    cols: 1,
    rows: 1,
    marginTopMm: 0,
    marginLeftMm: 0,
    colGapMm: 0,
    rowGapMm: 0,
  },
];

export const DEFAULT_SIZE_ID = 'avery-5160';

// Tamano por defecto de un field nuevo en mm (placeholder S47.1).
export const FIELD_DEFAULT_W_MM = 30;
export const FIELD_DEFAULT_H_MM = 8;

// MIME custom para HTML5 DnD del toolbar -> canvas.
export const DND_MIME = 'application/x-etiqueta-field';
